export const mutations = {
    setMarca(state, marca){
        state.marca = marca
    },
    setMarcas(state, marcas){
        state.marcas = marcas
    },
    setModalCadastroMarca(state, status){
        state.modalCadastroMarca = status
    },
    setModalExcluirMarca(state, status){
        state.modalExcluirMarca = status
    }
}

export default {}